import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { gate } from 'hub-http/gates';
import { useContext, useMemo } from 'react';
import { useSearchQuery } from '../../../../__generated__/chirp/com/hubspot/video/rpc/HubSpotVideoSearchRpc.hooks';
import { AuthContext } from '../../contexts/AuthContext';
export const INSERT_HUBSPOT_VIDEO_GATE = gate('MediaContent:CRM:HSVideoPicker');
export const useIsUngatedForHubSpotVideoInsert = () => {
  const auth = useContext(AuthContext);
  return Boolean(auth && auth.gates.includes(INSERT_HUBSPOT_VIDEO_GATE));
};
export const useHasMarketingVideoAccess = () => {
  const auth = useContext(AuthContext);
  return Boolean(auth && auth.user.scopes.includes('marketing-video'));
};
export const useHasOneToOneVideoAccess = () => {
  const auth = useContext(AuthContext);
  return Boolean(auth && auth.user.scopes.includes('one-to-one-video'));
};
export const useHasHubSpotVideos = (skip = false) => {
  const {
    data,
    loading,
    error
  } = useSearchQuery({
    variables: {
      count: 1,
      offset: 0
    },
    skip
  });
  if (error) {
    // default to true to allow users to open the video picker
    return {
      hasHubSpotVideos: true,
      loading: false
    };
  }
  return {
    hasHubSpotVideos: data ? data.total > 0 : false,
    loading
  };
};
const FETCH_DOMAINS = registerQuery({
  fieldName: 'domains',
  fetcher: () => http.get('/cos-domains/v1/domains')
});
export const useFetchEmailTrackingDomain = skip => {
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_DOMAINS, {
    skip
  });
  const domain = useMemo(() => {
    var _data$domains;
    if (!data) {
      return undefined;
    }
    const portalDomains = (_data$domains = data.domains) === null || _data$domains === void 0 ? void 0 : _data$domains.objects;
    const primaryEmailTrackingDomain = portalDomains === null || portalDomains === void 0 ? void 0 : portalDomains.find(({
      primaryEmailTracking,
      usageTypes
    }) => primaryEmailTracking || usageTypes.includes('PRIMARY_FOR_EMAIL_TRACKING'));
    if (primaryEmailTrackingDomain) {
      return primaryEmailTrackingDomain.domain;
    } else {
      const anyPrimaryOrUsedDomain = portalDomains === null || portalDomains === void 0 ? void 0 : portalDomains.find(({
        isUsedForEmailTracking,
        isAnyPrimary,
        isUsedForAnyContentType
      }) => isUsedForEmailTracking || isAnyPrimary || isUsedForAnyContentType);
      return anyPrimaryOrUsedDomain === null || anyPrimaryOrUsedDomain === void 0 ? void 0 : anyPrimaryOrUsedDomain.domain;
    }
  }, [data]);
  return {
    domain,
    loading,
    error
  };
};